module.exports = __webpack_public_path__ + "static/media/Analyze.5e3d573e.png";